import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTheme } from 'irmlib/styles'
import styled from 'styled-components'
import { uiGet } from 'irmlib/http'
import * as constants from 'irmlib/common/constants'

import { isAdmin, isSupervisor, isSuperUser } from '../../../../common/functions'
import { AllOpenJobs, AllJobsExceptionBoxes, qualityCheck } from '../../../../navigation/routePaths'
// import { currentJobs } from '../../../../services/reports/jobStatistic'
import { getUser } from '../../../../redux/global'
import { BaseCard, CardBody } from './BaseCard'
import { getJobStatisticsForDistrict } from '../../../../services/firestore/gdeJobs'
import { t } from 'i18next'

const jobsTemplate = [
  { backendKey: 'numOfOpenJobs', label: 'dashBoard.allOpenJobs', url: `${AllOpenJobs}` },
  { backendKey: 'numOfPendingJobs', label: 'dashBoard.unassignedJobs', url: `${AllOpenJobs}?status=${constants.jobStatus.pending}` },
  { backendKey: 'numberOfAssignedJobs', label: 'dashBoard.assignedJobs', url: `${AllOpenJobs}?status=${constants.jobStatus.assigned}` },
  { backendKey: 'numOfInProcessJobs', label: 'dashBoard.inProcessJobs', url: `${AllOpenJobs}?status=${constants.jobStatus.inProgress}` },
  { backendKey: 'numOfInReadytoTransmit', label: 'dashBoard.readyToTransmit', url: `${AllOpenJobs}?status=${constants.jobStatus.readyToTransmit}` },
  { backendKey: 'numOfQualityCheckJobs', label: 'dashBoard.qualityCheck', url: `${qualityCheck}` },
]

const boxTemplate = [
  { backendKey: 'numOfBoxesDataEntryInProcess', label: 'dashBoard.dataEntryInProcess' },
  { backendKey: 'numOfBoxesReadyForVerify', label: 'dashBoard.awaitingVerification' },
  { backendKey: 'numOfBoxesVerificationInProcess', label: 'dashBoard.verificationInProcess' },
  { backendKey: 'numOfBoxesReadyForQc', label: 'dashBoard.awaitingQualityCheck' },
  { backendKey: 'numOfBoxesQcInProcess', label: 'dashBoard.qualityCheckInProcess' },
  { backendKey: 'numOfBoxesReqReKey', label: 'dashBoard.requiresRekey' },
  { backendKey: 'numOfBoxesException', label: 'dashBoard.exception', url: `${AllJobsExceptionBoxes}` },
  { backendKey: 'numbOfBoxesReadyForTransmit', label: 'dashBoard.readyToTransmit' },
  { backendKey: 'numOfBoxesTransmitted', label: 'dashBoard.transmitted' },
]

const jobsHeaders = [
  { label: 'dashBoard.status', style: { width: '40%' } },
  { label: 'dashBoard.numberJobs', style: { width: '30%', textAlign: 'right' } },
]

const boxHeaders = [
  { label: 'dashBoard.status', style: { width: '40%' } },
  { label: 'dashBoard.numberBoxes', style: { width: '30%', textAlign: 'right' } },
]

const AdditionalTitleContainer = styled.div`
  font-weight: bold;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.palette.primary.main};
`

const CurrentJobsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const ColumnSpacer = styled.td`
  color: transparent;
`

const TableSpacer = () => 
  <table><thead><tr><ColumnSpacer>xxxxxx</ColumnSpacer></tr></thead></table>

export const CurrentJobs = () => {
  const isHavingAccess = isSupervisor() || isAdmin() || isSuperUser()
  const [data, setData] = useState({ 
    jobsData: jobsTemplate.map(e => {
      return [
        { label: e.label, url: e.url },
        0,
      ]
    }), 
    boxData: boxTemplate.map(e => {
      return [
        { label: e.label, url: e.url },
        0
      ]
    }) 
  })

  const service = async () => {
    const { district } = getUser()
    const data = await getJobStatisticsForDistrict(district)
    // const data = await currentJobs(district)
    /*
    // Mock data
    data.boxLevelInfo.numOfBoxesDataEntryInProcess = 1
    data.boxLevelInfo.numOfBoxesReadyForVerify = 2
    data.boxLevelInfo.numOfBoxesVerificationInProcess = 3
    data.boxLevelInfo.numOfBoxesReadyForQc = 4
    data.boxLevelInfo.numOfBoxesQcInProcess = 5
    data.boxLevelInfo.numOfBoxesReqReKey = 6
    data.boxLevelInfo.numbOfBoxesReadyForTransmit = 7
    data.boxLevelInfo.numOfBoxesTransmitted = 8

    data.boxLevelInfo.numOfBoxesSubmittedToday = 9
  
    data.jobInfo.numOfOpenJobs = 1
    data.jobInfo.numOfPendingJobs = 2
    data.jobInfo.numberOfAssignedJobs = 3
    data.jobInfo.numOfInProcessJobs = 4
    */

    const jobsData = jobsTemplate.map(e => {
      return [
        { label: e.label, url: e.url },
        data.jobInfo[e.backendKey],
      ]
    })
    const boxData = boxTemplate.map(e => {
      return [
        { label: e.label, url: e.url },
        data.boxLevelInfo[e.backendKey]
      ]
    })
    // jobsData[0][1] = jobsData[1][1] + jobsData[2][1] + jobsData[3][1]
    return { jobsData, boxData }
  }

  useEffect(() => {
    const doGet = async () => {
      const data = await uiGet({ service })
      setData(data)
    }
    doGet()
  }, [])

  const AdditionalTitle = () => {
    const theme = useTheme()
    return (
      <AdditionalTitleContainer>
        {`${t('dashBoard.jobsFor')} `}
        <StyledLink id='dashBoard-district' to={AllOpenJobs} theme={theme}>
          {getUser().district}
        </StyledLink>
        {` ${t('dashBoard.district')} `}
      </AdditionalTitleContainer>
    )
  }

  return (
    <>
      <BaseCard
        id={'CurrentJobs'}
        body={
          <CurrentJobsContainer>
            <CardBody additionalTitle={isHavingAccess && <AdditionalTitle />} headers={jobsHeaders} data={data?.jobsData} />
            <TableSpacer />
            <CardBody headers={boxHeaders} data={data?.boxData} />
          </CurrentJobsContainer>
        } 
        title={t('dashBoard.currentJobs')}
      />
    </>
  )
}